import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-dr-kanishka-jain',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './dr-kanishka-jain.html',
  styleUrl: './dr-kanishka-jain.css',
})
export class DrKanishkaJain {}
